var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "assessment",
    width: "31px",
    height: "37px",
    viewBox: "0 0 31 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "assessment-1",
    d: "M22.5550032,2.75828139 L24.9449968,3.49171861 L21.4926159,14.7417186 L21.4671325,14.8162916 C20.6354418,17.0204431 21.6416058,17.9166667 25.6770833,17.9166667 C26.37587,17.9166667 26.9389438,18.4895323 26.9268976,19.1882152 L26.8904971,21.7015689 L26.876875,23.10375 L26.9628066,23.1413541 C27.1515546,23.2227823 27.3829008,23.3150295 27.6552048,23.4170801 L28.0015243,23.5441814 L28.5097306,23.7230067 C29.7674903,24.1565299 31.528599,24.7037918 33.7874324,25.3624803 C34.9336067,25.6967111 35.0036632,27.2939768 33.891153,27.7272742 L33.3062373,27.9596543 C31.5009954,28.6916538 30.1425654,29.3863765 29.2421727,30.0295141 C28.443619,30.5999096 28.125,31.0344749 28.125,31.25 C28.125,33.95753 29.5181272,35.557421 32.31929,35.6229079 L32.5,35.625 L32.5,38.125 C28.1369367,38.125 25.625,35.341956 25.625,31.25 C25.625,29.6356239 26.9878596,28.2436109 29.6759471,26.8586193 L29.80625,26.791875 L28.6693675,26.4400204 C25.1842924,25.3370896 24.4003376,24.8096807 24.3756126,23.8007608 L24.38285,22.3952593 L24.408125,20.3725 L24.2385065,20.3599953 C19.7593981,19.9885998 17.7503443,17.8017824 19.0686871,14.0957947 L19.115,13.966875 L22.5550032,2.75828139 Z M6.2375,18.525 L8.0375,19.05 L7.775,19.95 C6.40472973,24.6480695 6.3676954,29.335996 7.66389701,34.0335173 L7.775,34.425 L8.0375,35.325 L6.2375,35.85 L5.975,34.95 C4.50534188,29.9111722 4.46765834,24.8621724 5.86194938,19.822823 L5.975,19.425 L6.2375,18.525 Z M9.98862045,19.7966273 L11.8049352,20.2620579 L11.5722199,21.1702153 C10.5779212,25.0504053 10.5447779,28.9236808 11.47279,32.8034098 L11.5722199,33.2047847 L11.8049352,34.1129421 L9.98862045,34.5783727 L9.75590512,33.6702153 C8.68477755,29.4902053 8.65022504,25.3032654 9.65224761,21.1228083 L9.75590512,20.7047847 L9.98862045,19.7966273 Z M14.0932592,21.0506143 L15.9122764,21.5053686 L15.6848992,22.4148771 C14.9195036,25.4764597 14.8900653,28.5316704 15.5965843,31.5927627 L15.6848992,31.9601229 L15.9122764,32.8696314 L14.0932592,33.3243857 L13.865882,32.4148771 C13.0263217,29.0566356 12.9963374,25.6919858 13.7759291,22.3332865 L13.865882,21.9601229 L14.0932592,21.0506143 Z M30.625,5.625 C32.1783009,5.625 33.4375,6.88419914 33.4375,8.4375 C33.4375,9.99080086 32.1783009,11.25 30.625,11.25 C29.0716991,11.25 27.8125,9.99080086 27.8125,8.4375 C27.8125,6.88419914 29.0716991,5.625 30.625,5.625 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assessment-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assessment-3",
    transform: "translate(-20.000000, -70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assessment-4",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assessment-5",
    transform: "translate(16.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assessment-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "assessment-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "assessment-8",
    xlinkHref: "#assessment-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "assessment-9",
    fill: "#151515",
    fillRule: "nonzero",
    xlinkHref: "#assessment-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.a0f26e95ef34423684bccf702212108c.svg";
export { ForwardRef as ReactComponent };